import { render, staticRenderFns } from "./HeaderActionProjectButtons.vue?vue&type=template&id=1ef1923c"
import script from "./HeaderActionProjectButtons.vue?vue&type=script&lang=js"
export * from "./HeaderActionProjectButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports